<template>
    <div
        class="modal login-form-popup fade register-modal"
        id="register"
        tabindex="-1"
        aria-labelledby="register"
        aria-hidden="true"
        data-keyboard="false"
        data-backdrop="static"
    >
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
                <!-- Modal Header -->
                <div class="modal-header">
                    <h4 class="modal-title">Sign Up</h4>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        @click="closeRegisterModel"
                    >
                        &times;
                    </button>
                </div>
                <div class="modal-body pt-2">
                    <div class="login-form">
                        <p class="mb-0 mt-1 text-left">
                            Please fill this form to create an account!
                        </p>
                        <form
                            method="post"
                            @submit.prevent="onSubmitToRegister"
                            data-vv-scope="signupform"
                            :key="'signupform'"
                        >
                            <div class="row justify-content-between">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="Name"
                                            name="first_name"
                                            v-model="
                                                registration_data.first_name
                                            "
                                            v-validate="'required|max:100'"
                                            data-vv-as="First Name"
                                        />
                                        <label>First Name</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.first_name'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.first_name"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="Last"
                                            name="last_name"
                                            v-model="
                                                registration_data.last_name
                                            "
                                            v-validate="'required|max:100'"
                                            data-vv-as="Last Name"
                                        />
                                        <label>Last Name</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.last_name'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.last_name"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <input
                                    type="text"
                                    class="form-control"
                                    id="Email2"
                                    name="email"
                                    autocomplete="off"
                                    v-model="registration_data.email"
                                    v-validate="'required|email'"
                                />
                                <label>Email ID</label>
                                <span class="highlight"></span>
                                <span class="bar"></span>
                                <small
                                    class="form-text text-error text-left"
                                    v-show="errors.has('signupform.email')"
                                >
                                    {{ errors.first("signupform.email") }}
                                </small>
                            </div>

                            <div class="row justify-content-between">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="password"
                                            class="form-control"
                                            id="Password2"
                                            name="password"
                                            autocomplete="off"
                                            v-model="registration_data.password"
                                            v-validate="'required|min:6|max:16'"
                                            ref="password"
                                        />
                                        <label>Password</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.password'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.password"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div class="form-group">
                                        <input
                                            type="password"
                                            class="form-control"
                                            id="Password3"
                                            name="confirm_password"
                                            v-model="
                                                registration_data.confirm_password
                                            "
                                            v-validate="
                                                'required|max:16|confirmed:password'
                                            "
                                            data-vv-as="confirm password"
                                        />
                                        <label>Confirm Password</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.confirm_password'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.confirm_password"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>
                            <div class="row justify-content-between">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <v-select
                                            label="name"
                                            :options="user_type"
                                            v-model="
                                                registration_data.user_type
                                            "
                                            v-validate="'required'"
                                            data-vv-as="User Type"
                                            name="user_type"
                                        ></v-select>
                                        <label class="user-type type_label"
                                            >User Type</label
                                        >
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.user_type'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.user_type"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                                <div
                                    class="col-md-6"
                                    v-if="
                                        registration_data.user_type ==
                                        'Business'
                                    "
                                >
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="business_name"
                                            name="business_name"
                                            v-model="
                                                registration_data.business_name
                                            "
                                            data-vv-as="Business Name"
                                            v-validate="
                                                registration_data.user_type ==
                                                'Business'
                                                    ? 'required|max:100'
                                                    : ''
                                            "
                                        />
                                        <label>Business Name</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.business_name'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.business_name"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                                <div
                                    class="col-md-6"
                                    v-else-if="
                                        registration_data.user_type ==
                                        'School'
                                    "
                                >
                                    <div class="form-group">
                                        <input
                                            type="text"
                                            class="form-control"
                                            id="school_name"
                                            name="school_name"
                                            v-model="
                                                registration_data.school_name
                                            "
                                            data-vv-as="School Name"
                                            v-validate="
                                                registration_data.user_type ==
                                                'School'
                                                    ? 'required|max:100'
                                                    : ''
                                            "
                                        />
                                        <label>School Name</label>
                                        <span class="highlight"></span>
                                        <span class="bar"></span>
                                        <small
                                            class="form-text text-error text-left"
                                            v-show="
                                                errors.has(
                                                    'signupform.school_name'
                                                )
                                            "
                                        >
                                            {{
                                                errors.first(
                                                    "signupform.school_name"
                                                )
                                            }}
                                        </small>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group captcha_div_register">
                                <!-- <vue-recaptcha ref="recaptcha" sitekey="" /> -->
                                <!-- <vue-recaptcha sitekey="6LcIok4gAAAAAB3IKZM6hn261--HM41vdNG8bE4_"></vue-recaptcha> -->
                                <vue-recaptcha
                                    v-if="sitekey"
                                    ref="recaptcha"
                                    :sitekey="sitekey"
                                    @verify="verifyCaptcha"
                                    @expire="onCaptchaExpired"
                                />
                                <div
                                    v-show="captchaErrMsg"
                                    id="duplicate_"
                                ></div>
                            </div>

                            <div
                                class="form-check text-left w-100 pb-0 mb-0 mt_20"
                            >
                                <label class="m-0 d-inline-block">
                                    <p class="text-left ml-2 mb-0">
                                        I accept the
                                        <a
                                            href="#"
                                            data-toggle="modal"
                                            data-target="#terms_of_use"
                                            >Terms of use</a
                                        >
                                        &
                                        <a
                                            href="#"
                                            data-toggle="modal"
                                            data-target="#privacy_policy"
                                            >Privacy Policy</a
                                        >.
                                    </p>
                                    <input
                                        type="checkbox"
                                        checked="checked"
                                        name="accept_terms"
                                        v-model="registration_data.accept_terms"
                                        v-validate="'required'"
                                        data-vv-as="Accept Terms"
                                    />
                                    <span class="checkmark"></span>

                                    <p
                                        class="form-text text-error text-left"
                                        v-show="
                                            errors.has(
                                                'signupform.accept_terms'
                                            )
                                        "
                                    >
                                        {{
                                            errors.first(
                                                "signupform.accept_terms"
                                            )
                                        }}
                                    </p>
                                </label>
                            </div>

                            <!-- <div class="beta-notice text-left">
                                <span class="beta-notice__badge">Beta</span>
                                <span class="beta-notice__text"
                                    >This website is currently in beta — you
                                    may encounter occasional issues.</span
                                >
                            </div> -->

                            <button
                                type="submit"
                                class="btn btn_orange bg_primary_orange text_white w-100 mt_14 mb_32 btn_h60"
                            >
                                Sign up
                            </button>
                            <div class="d-md-flex">
                                <p class="small ml-auto">
                                    Already have an account?
                                    <a
                                        href="#"
                                        class="btn-link login-cart"
                                        data-path="/MyAccount"
                                        data-toggle="modal"
                                        data-target="#login"
                                        data-dismiss="modal"
                                        >Login</a
                                    >
                                </p>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueRecaptcha from "@/components/VueRecaptcha.vue";
/**
 * Component Usage
 * <register-modal>
 */
import { REGISTER, LOGOUT } from "@/store/actions.type";

export default {
    name: "register-modal",
    props: [],
    data() {
        return {
            isLoader: false,
            sitekey: "6LeO510lAAAAAEo-dFZ50cbrWaS4gRPnEqFi-_X3", // OLD KEY: 6Ld8A1IgAAAAAC5RTdjFW82Y_RYAbVrNVltIaoLe
            recaptcha: null,
            captchaErrMsg: true,
            user_type: ["Individual", "Business", "School"],
            registration_data: {
                first_name: null,
                last_name: null,
                email: null,
                password: null,
                confirm_password: null,
                accept_terms: null,
                user_type: "Individual",
                business_name: "",
                school_name: ""
            }
        };
    },
    components: { VueRecaptcha },
    computed: {},
    watch: {},
    mounted() {
        this.registration_data.user_type = "Individual";
    },
    methods: {
        verifyCaptcha(response) {
            this.recaptcha = response;
            if (this.recaptcha) {
                this.captchaErrMsg = false;
            }
        },
        onCaptchaExpired() {
            this.$refs.recaptcha.reset();
        },
        closeRegisterModel() {
            /* eslint-disable */
            this.captchaErrMsg = false;
            grecaptcha.reset();
            /* eslint-enable */
        },
        onSubmitToRegister() {
            var _this = this;
            this.$store.dispatch(LOGOUT);
            // this.$refs.recaptcha.execute();
            /* eslint-disable */
            this.$validator.validateAll("signupform").then((isValid) => {
                if (!this.recaptcha) {
                    $("#duplicate_").html(
                        "<small class='form-text text-error'> Please verify Recaptcha</small>"
                    );
                    this.captchaErrMsg = true;
                    return true;
                } else {
                    $("#duplicate_").html("");
                }
                if (isValid) {
                    this.$store
                        .dispatch(REGISTER, {
                            first_name: this.registration_data.first_name,
                            last_name: this.registration_data.last_name,
                            email: this.registration_data.email,
                            password: this.registration_data.password,
                            confirm_password:
                                this.registration_data.confirm_password,
                            user_type: this.registration_data.user_type,
                            business_name: this.registration_data.business_name,
                            school_name: this.registration_data.school_name
                        })
                        .then(() => {
                            // $("#register").modal("hide");
                            _this.$toast.success(
                                "User Registered Successfully.",
                                {
                                    position: "top-right"
                                }
                            );
                            $("#register").modal("hide");
                            $("#useractive").modal("show");
                            _this.$validator.reset();
                            //document.getElementById("register-popup-close").click();
                            _this.registration_data = {
                                first_name: null,
                                last_name: null,
                                email: null,
                                password: null,
                                confirm_password: null,
                                accept_terms: null,
                                user_type: "Individual",
                                business_name: "",
                                school_name: ""
                            };
                            grecaptcha.reset();
                        })
                        .catch((response) => {
                            if (response) {
                                _this.errors.itemslength = 0;
                                _this.errors.items.push({
                                    id: 4,
                                    vmId: 5,
                                    field: "email",
                                    msg: response.data.error,
                                    scope: "signupform"
                                });
                                _this.$toast.error(response.data.error, {
                                    position: "top-right"
                                });
                            }
                        });
                } else {
                }
            });
            /* eslint-enable */
        }
    }
};
</script>
<style>
.register-modal .modal-dialog .vs__selected {
    margin: 25px 0px 0;
    padding: 0px;
}
.register-modal .modal-dialog .vs__search {
    height: 46px;
    padding: 15px 10px 5px 0px !important;
    display: block;
    width: 100%;
    border: none;
    border-bottom: 1px solid #707070;
    border-radius: 0px;
    font-size: 18px;
    font-weight: 500;
    color: #000 !important;
    opacity: 1;
}
.register-modal .modal-dialog .user-type {
    top: -5px;
    font-size: 14px;
    color: #000;
}
.register-modal .beta-notice {
    display: flex;
    align-items: baseline;
    flex-wrap: wrap;
    gap: 6px;
    margin: 14px 0 0;
}
.register-modal .beta-notice__badge {
    flex-shrink: 0;
    color: #ff5722;
    background: transparent;
    border: 1px solid currentColor;
    font-size: 10px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-radius: 3px;
    padding: 1px 6px;
    line-height: 1.4;
}
.register-modal .beta-notice__text {
    font-size: 12px;
    color: #888;
}
</style>
